import PackagesCarouselContainerMobile from '../../../../components/containers/PackagesCarouselContainerMobile';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFaresPackageCarousel';

const cmpConfig = {
  name: 'packages-carousel',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: PackagesCarouselContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
